"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchRebalanceEvents = fetchRebalanceEvents;
exports.calculateRebalanceHistoryFromEvents = calculateRebalanceHistoryFromEvents;
const tslib_1 = require("tslib");
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const maps_js_1 = require("../../common/maps.js");
const fetchEvents_js_1 = require("./fetchEvents.js");
const coins_js_1 = require("../../common/coins.js");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
async function fetchRebalanceEvents(params) {
    const eventTypesSet = new Set();
    if (params.poolNames) {
        params.poolNames.forEach((poolName) => {
            const eventType = maps_js_1.poolInfo[poolName].rebalanceEventType;
            if (eventType !== undefined && eventType !== null && eventType !== "") {
                eventTypesSet.add(eventType);
            }
        });
    }
    else {
        // Iterate over all the values in poolInfo and add each rebalanceEventType to the Set
        Object.values(maps_js_1.poolInfo).forEach((info) => {
            const eventType = info.rebalanceEventType;
            if (eventType !== undefined && eventType !== null && eventType !== "") {
                eventTypesSet.add(eventType);
            }
        });
    }
    const eventTypes = Array.from(eventTypesSet);
    const eventsPromises = eventTypes.map(async (eventType) => {
        const events = (await (0, fetchEvents_js_1.fetchEvents)({
            startTime: params.startTime,
            endTime: params.endTime,
            eventTypes: [eventType],
            order: params.order,
        })).filter((e) => {
            if (params.poolNames) {
                return params.poolNames
                    .map((poolName) => maps_js_1.poolInfo[poolName].investorId)
                    .includes(e.investor_id);
            }
            else {
                return true;
            }
        });
        return events;
    });
    const events = (await Promise.all(eventsPromises)).flat();
    const rebalanceEvents = events.map((e) => {
        return e;
    });
    return rebalanceEvents;
}
async function calculateRebalanceHistoryFromEvents(events) {
    const rebalanceHistoryMap = {};
    const investorPoolNameMap = await (0, maps_js_1.getInvestorPoolMap)();
    for (const e of events) {
        const event = e;
        const poolName = investorPoolNameMap.get(event.investor_id);
        if (poolName) {
            if (!rebalanceHistoryMap[poolName]) {
                rebalanceHistoryMap[poolName] = [];
            }
            const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
            const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
            const after_price = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToPrice(new bn_js_1.default(event.sqrt_price_after), coins_js_1.coinsList[pool1].expo, coins_js_1.coinsList[pool2].expo);
            const lower_tick = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(Number(event.lower_tick_after) > Math.pow(2, 31)
                ? Number(event.lower_tick_after) - Math.pow(2, 32)
                : Number(event.lower_tick_after), coins_js_1.coinsList[pool1].expo, coins_js_1.coinsList[pool2].expo);
            const upper_tick = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(Number(event.upper_tick_after) > Math.pow(2, 31)
                ? Number(event.upper_tick_after) - Math.pow(2, 32)
                : Number(event.upper_tick_after), coins_js_1.coinsList[pool1].expo, coins_js_1.coinsList[pool2].expo);
            const history = {
                timestamp: e.timestamp.toString(),
                lower_tick: lower_tick.toString(),
                upper_tick: upper_tick.toString(),
                after_price: after_price.toString(),
                amount_a_before: e.amount_a_before,
                amount_b_before: e.amount_b_before,
                amount_a_after: e.amount_a_after,
                amount_b_after: e.amount_b_after,
            };
            rebalanceHistoryMap[poolName].push(history);
        }
    }
    return rebalanceHistoryMap;
}
//# sourceMappingURL=fetchRebalanceEvents.js.map